export enum ButtonVariantEnum {
  QUIT = 'QUIT',
  UPDATE = 'UPDATE',
  CONFIRM = 'CONFIRM',
  SEND = 'SEND',
  OK = 'OK',
  REPLACE = 'REPLACE',
  EXLCLUDE = 'EXLCLUDE',
}
